import React from "react";
import "./Failure.sass";
import { ReactComponent as CardMedia } from "assets/_CardMedia_.svg";

interface IProps {
  refresh: () => void;
  onClose: () => void;
}

const Failure: React.FC<IProps> = (props) => {
  return (
    <div className="failure-overlay">
      <div className="failure-modal">
        <div className="failure-illustration">
          <CardMedia />
        </div>
        <h2 className="failure-title">We're having trouble loading the data.</h2>
        <p className="failure-description">
          Please try refreshing the page. If the problem persists, logout and login again or close the tab and browser and open again.
        </p>
        <div className="failure-actions">
          <button className="failure-btn failure-btn-secondary" onClick={props.onClose}>
            Go Back
          </button>
          <button className="failure-btn failure-btn-primary" onClick={props.refresh}>
            Refresh Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default Failure;
